// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import AddressForm from '../../../../../../elements/AddressForm/AddressForm';
import RadioButton from "../../../../../../elements/RadioButton/RadioButton";
import { getFullAdmin } from "../../../../../../utils/address";
import classNames from 'classnames/bind';

import style from '../../CheckoutStep.scss';

import type { Option } from '../../../../../../elements/Select/Select';
import type { Address, Admin, Country } from '../../../../../../entities';
import icons from '../../../../../../assets/styles/icons.scss';

type Props = {
  +handleChangeAdmin1: (option: Option) => void;
  +handleChangeAdmin2: (option: Option) => void;
  +handleChangeAdmin3: (option: Option) => void;
  +handleChange: (e: SyntheticInputEvent<HTMLInputElement>) => void;
  +handleChangeAddressOption: (option: Option) => void;
  +handleChangeSaveAddress: () => void;
  +handleChangePhone: (e: Event) => void;
  +handleFocus: (e: Event) => void;
  +handlePhoneInit: (cleave: any) => void;
  +addresses: Address[];
  +country: Country;
  +admin1: {
    value: string;
    label?: string;
    errors?: string[];
  };
  +admin1Items: Admin[];
  +isLoadingAdmin1?: boolean;
  +admin2: {
    value: string;
    label?: string;
    errors?: string[];
  };
  +admin2Items: Admin[];
  +isLoadingAdmin2?: boolean;
  +admin3: {
    value: string;
    label?: string;
    errors?: string[];
  };
  +admin3Items: Admin[];
  +isLoadingAdmin3?: boolean;
  +address1: {
    value: string;
    errors?: string[];
  };
  +address2: {
    value: string;
    errors?: string[];
  };
  +firstName: {
    value: string;
    errors?: string[];
  };
  +idNumber: {
    value: string;
    errors?: string[];
  };
  +lastName: {
    value: string;
    errors?: string[];
  };
  +name: {
    value: string;
    errors?: string[];
  };
  +phone: {
    value: string;
    errors?: string[];
  };
  +zipCode: {
    value: string;
    errors?: string[];
  };
  +saveAddress: {
    value: boolean;
  };
  +addressOption: {
    value: string;
    errors?: string[];
  };
};

export class MyAddress extends Component<Props> {

  handleChangeOption = (e: SyntheticInputEvent<HTMLInputElement>) => {
    const { handleChangeAddressOption } = this.props;
    if (e.target instanceof HTMLInputElement && handleChangeAddressOption) {
      handleChangeAddressOption({ value: e.target.value });
    }
  };

  render() {
    const {
      handleChangeAdmin1, handleChangeAdmin2, handleChangeAdmin3,
      handleChange, handleChangeAddressOption, handleChangePhone, handleFocus, handleChangeSaveAddress, handlePhoneInit,
      country, addresses, admin1, admin1Items, isLoadingAdmin1, admin2, admin2Items, isLoadingAdmin2, admin3,
      admin3Items, isLoadingAdmin3, address1, address2, firstName, idNumber, lastName, name, phone, zipCode,
      saveAddress, addressOption,
    } = this.props;
    const addressesOptions = addresses.map((address: Address, index: number) =>
      <article key={index}
               className={classNames(style.addressOption,
                 { [style.selected]: addressOption.value === address.id })}
               onClick={_ => handleChangeAddressOption({ value: address.id })}>
        <div className={style.left}>
          <RadioButton handleChange={_ => {
          }}
                       name="address"
                       value={address.id}
                       selected={addressOption.value}>
            <p className={classNames(style.name, style.desktop)}>{address.name}</p>
          </RadioButton>
        </div>
        <div className={style.right}>
          <p className={classNames(style.name, style.tablet)}>{address.name}</p>
          <p>{`${address.firstName} ${address.lastName}, ${address.idNumber}`}</p>
          <p>{`${address.address1}, ${getFullAdmin(address)}. ${address.zipCode}`}</p>
          <FormattedMessage id="newOrder.checkout.deliveryAddress.phone">{
            txt => <p>{txt}: {address.phone}</p>
          }</FormattedMessage>
        </div>
      </article>
    );
    const myAddressOptions = [
      ...addressesOptions,
      <article key="new-address"
               className={classNames(style.addressOption, style.myAddressOption)}
               onClick={_ => handleChangeAddressOption({ value: 'new-address' })}>
        <div className={style.button}>
          <i className={icons.symbolPlus}/>
        </div>
        <FormattedMessage id="address.myAddresses.option.addNewAddress">{
          txt => <p className={style.newAddress}>{txt}</p>
        }</FormattedMessage>
      </article>
    ];
    return (
      <Fragment>
        <FormattedMessage id={addressOption.value === 'new-address' ? "newOrder.checkout.deliveryAddress.title.fill" :
          "newOrder.checkout.deliveryAddress.title.choose"}>{
          txt => <h2 className={style.title}>1. {txt}</h2>
        }</FormattedMessage>
        {addressOption.value !== 'new-address' &&
        <div className={style.optionsWrap}>
          {myAddressOptions}
        </div>}
        {addressOption.value === 'new-address' &&
        <AddressForm type="myAddress"
                     handleChangeAdmin1={handleChangeAdmin1}
                     handleChangeAdmin2={handleChangeAdmin2}
                     handleChangeAdmin3={handleChangeAdmin3}
                     handleChange={handleChange}
                     handleChangeAddressOption={handleChangeAddressOption}
                     handleChangePhone={handleChangePhone}
                     handleFocus={handleFocus}
                     handleSaveAddress={handleChangeSaveAddress}
                     isPosting={/*isPosting*/false}
                     addresses={addresses}
                     country={{ value: country }}
                     admin1={admin1}
                     admin2={admin2}
                     admin3={admin3}
                     admin1Items={admin1Items}
                     admin2Items={admin2Items}
                     admin3Items={admin3Items}
                     isLoadingAdmin1={isLoadingAdmin1}
                     isLoadingAdmin2={isLoadingAdmin2}
                     isLoadingAdmin3={isLoadingAdmin3}
                     address1={address1}
                     address2={address2}
                     firstName={firstName}
                     idNumber={idNumber}
                     lastName={lastName}
                     name={name}
                     phone={phone}
                     zipCode={zipCode}
                     saveAddress={saveAddress && saveAddress.value}
                     handlePhoneInit={handlePhoneInit}
                     addressOption={addressOption}/>}
      </Fragment>
    );
  }
}

MyAddress.propTypes = {
  handleChangeAdmin1: PropTypes.func.isRequired,
  handleChangeAdmin2: PropTypes.func.isRequired,
  handleChangeAdmin3: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleChangeAddressOption: PropTypes.func.isRequired,
  handleChangeSaveAddress: PropTypes.func.isRequired,
  handleChangePhone: PropTypes.func.isRequired,
  handleFocus: PropTypes.func.isRequired,
  handlePhoneInit: PropTypes.func.isRequired,
  addresses: PropTypes.array.isRequired,
  country: PropTypes.string.isRequired,
  admin1: PropTypes.object.isRequired,
  admin1Items: PropTypes.array,
  isLoadingAdmin1: PropTypes.bool,
  admin2: PropTypes.object.isRequired,
  admin2Items: PropTypes.array,
  isLoadingAdmin2: PropTypes.bool,
  admin3: PropTypes.object.isRequired,
  admin3Items: PropTypes.array,
  isLoadingAdmin3: PropTypes.bool,
  address1: PropTypes.object.isRequired,
  address2: PropTypes.object.isRequired,
  firstName: PropTypes.object.isRequired,
  idNumber: PropTypes.object.isRequired,
  lastName: PropTypes.object.isRequired,
  name: PropTypes.object.isRequired,
  phone: PropTypes.object.isRequired,
  zipCode: PropTypes.object.isRequired,
  saveAddress: PropTypes.object.isRequired,
  addressOption: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/new-order/CheckoutStep/components/DeliveryMethods/MyAddress/MyAddress.jsx